const validatePreferences = (name, preferences) => {
  if (!preferences) {
    return { [name]: 'Invalid Data' }
  }
  if (!preferences.filter(pref => pref).length) {
    return { [name]: 'Select your preference' }
  }

  return {}
}

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { preferences } = values

  return {
    ...validatePreferences('preferences', preferences),
  }
}

export default validate
